/**
 * Check if key exists in local storage
 * @param  string key
 * @return boolean
 */
export const localStorageHas = (key: string) => {
  const item = localStorage.getItem(key);

  return ( item !== null );
}

/**
 * Retrive an object from local storage.
 * @param  string key
 * @return mixed
 */
export const localStorageGet = (key: string) => {
  const item = localStorage.getItem(key);

  if ( ! item ) return null;

  if ( item[0] === '{' || item[0] === '[' ) return JSON.parse(item);

  return item;
}

/**
 * Save some value to local storage.
 * @param string key    
 * @param string value
 */
export const localStorageSet = (key: string, value: any) => {
  if ( value === undefined ) console.error("Can't store undefinded value");

  if ( typeof(value) === 'object' ) {
    value = JSON.stringify(value);
  }

  if ( typeof(value) !== 'string' ) console.error("Can't store unrecognized format value");

  localStorage.setItem(key, value);
}

/**
 * Remove element from local storage.
 * @param string key 
 */
export const localStorageRemove = (key: string) => {
  localStorage.removeItem(key);
}


/**
 * Clean all from local storage.
 */
export const localStorageClean = () => {
  localStorage.clear();
}

export const setCookie = (name: any,value: any, days : any) => {
  let expires = "";
  if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

